// stores/operatorProfileStore.ts
import { create } from 'zustand';
import apiClient from '../apiSetup/axiosInterceptor';

interface Operator {
  user_id: string;
  name: string;
  email: string;
  mobileNumber: string | null;
  role: string;
}

interface OperatorProfile {
  operator: Operator;
  institute_id: string;
  institute_name: string;
  branch_id: string;
  branch_name: string;
  branch_code: string | null;
  branch_email: string | null;
  branch_contact_no: string | null;
  branch_license_number: string | null;
  branch_license_start: string | null;
  branch_license_expiry: string | null;
  branch_state: string | null;
  branch_district: string | null;
  branch_village: string | null;
  branch_type: string | null;
  branch_address: string | null;
  branch_pincode: number | null;
  branch_total_pc: number | null;
  branch_capacity: number | null;
  branch_status: string | null;
  branch_latitude: number | null;
  branch_longitude: number | null;
  branch_opening_time: string | null;
  branch_closing_time: string | null;
  branch_created_at: string | null;
  branch_created_by: string | null;
}

interface ApiResponse {
  success: boolean;
  data: OperatorProfile;
}

interface OperatorProfileState {
  profile: OperatorProfile | null;
  loading: boolean;
  error: string | null;
  fetchProfile: () => Promise<void>;
  clearError: () => void;
}

export const useOperatorProfileStore = create<OperatorProfileState>((set) => ({
  profile: null,
  loading: false,
  error: null,
  clearError: () => set({ error: null }),
  fetchProfile: async () => {
    set({ loading: true, error: null });
    try {
      const response = await apiClient.get<ApiResponse>('/v1/admin/operator-profile');
      // Access response.data.data because API wraps it in { success: true, data: {...} }
      console.log(JSON.stringify(response.data, null, 2));
      set({ profile: response.data.data, loading: false });
    } catch (err: any) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'Failed to load operator profile';
      set({ error: message, loading: false });
    }
  },
}));